<template>
    <div>
        <div class="career-page">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <form @submit.prevent="submitCareer">
                            <div class="form-group">
                                <h1>APPLICATION FOR EMPLOYMENT</h1>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-8">
                                    <label class="labelbor">Position Applying for:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="jobTitle" readonly>
                                    </label>
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Date:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" :value="getDate" readonly>
                                    </label>
                                </div>                                
                            </div>

                             <div class="form-group">
                                <h2>APPLICANT INFORMATION</h2>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Name (Last, First):&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.name">
                                    </label>
                                </div>                               
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label>Street Address:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.street">
                                    </label>
                                </div>                               
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <label class="labelbor">City:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.city">
                                    </label>
                                </div>   
                                <div class="form-group col-md-3">
                                    <label class="labelbor">State:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.state">
                                    </label>
                                </div> 
                                <div class="form-group col-md-4">
                                    <label>Zip code:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.zip">
                                    </label>
                                </div>                             
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label class="labelbor">Phone:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.phone">
                                    </label>
                                </div>   
                                <div class="form-group col-md-6">
                                    <label>Email:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.email">
                                    </label>
                                </div>                         
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-7">
                                 <label class="form-check-input-main">Have you ever worked or attended school under any other names?</label>
                                    <input class="form-check-input" type="radio" value="Yes" v-model="form.othernameoption">
                                        <label class="form-check-label">
                                            Yes
                                        </label>
                                    <input class="form-check-input" type="radio" value="No" v-model="form.othernameoption">
                                        <label class="form-check-label">
                                            No
                                        </label>
                                </div>  
                                <div class="form-group col-md-5">
                                    <label>If yes, please explain:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.othername">
                                    </label>
                                </div>                            
                            </div>

                            <div class="form-group">
                                <h2>ELIGIBILITY</h2>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                 <label class="form-check-input-main">Availability:</label>
                                    <input class="form-check-input" type="radio" value="Full-time" v-model="form.availability">
                                        <label class="form-check-label">
                                            Full-time
                                        </label>
                                    <input class="form-check-input" type="radio" value="Part-time" v-model="form.availability">
                                        <label class="form-check-label">
                                            Part-time
                                        </label>                                        
                                    <input class="form-check-input" type="radio" value="Temporary" v-model="form.availability">
                                        <label class="form-check-label">
                                            Temporary
                                        </label>                                        
                                    <input class="form-check-input" type="radio" value="Seasonal" v-model="form.availability">
                                        <label class="form-check-label">
                                            Seasonal
                                        </label>
                                </div>                             
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label  class="labelbor">Date you can start:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.startdate">
                                    </label>
                                </div>   
                                <div class="form-group col-md-6">
                                    <label>Desired salary: &nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.salary">
                                    </label>
                                </div>                               
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-7">
                                 <label class="form-check-input-main">Have you applied at Qualtek before?  </label>
                                    <input class="form-check-input" type="radio" value="Yes" v-model="form.already_appliedoption">
                                        <label class="form-check-label">
                                            Yes
                                        </label>
                                    <input class="form-check-input" type="radio" value="No" v-model="form.already_appliedoption">
                                        <label class="form-check-label">
                                            No
                                        </label>
                                </div>  
                                <div class="form-group col-md-5">
                                    <label>If yes, please give date:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.alreadyapplied_date">
                                    </label>
                                </div>                            
                            </div>

                            <div class="form-row form-dual-row">
                                <div class="form-group col-md-7 pdt-25">
                                 <label class="form-check-input-main">Have you worked for Qualtek before?   </label>
                                    <input class="form-check-input" type="radio" value="Yes" v-model="form.already_employedoption">
                                        <label class="form-check-label">
                                            Yes
                                        </label>
                                    <input class="form-check-input" type="radio" value="No" v-model="form.already_employedoption">
                                        <label class="form-check-label">
                                            No
                                        </label>
                                </div>  
                                <div class="form-group col-md-5">
                                    <label>Latest position held:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.alreadyemployed_position">
                                    </label>
                                    <label>Dates:&nbsp;&nbsp;&nbsp;
                                    <input type="text" class="form-control" v-model="form.alreadyemployed_date">
                                    </label>
                                </div>                            
                            </div>

                            <div class="form-row  form-dual-row">
                                <div class="form-group col-md-12">
                                 <label class="form-check-input-main">How did you hear about us? </label>
                                    <input class="form-check-input" type="radio" value="Walk-in" v-model="form.reference">
                                        <label class="form-check-label">
                                            Walk-in                                
                                        </label>
                                    <input class="form-check-input" type="radio" value="Qualtek Website" v-model="form.hear_at">
                                        <label class="form-check-label">
                                           Qualtek Website
                                        </label>                                        
                                    <input class="form-check-input" type="radio" value="Word of Mouth" v-model="form.hear_at">
                                        <label class="form-check-label">
                                            Word of Mouth 
                                        </label>                                        
                                    <input class="form-check-input" type="radio" value="Social Media" v-model="form.hear_at">
                                        <label class="form-check-label">
                                            Social Media
                                        </label>                                     
                                    <input class="form-check-input" type="radio" value=" Job Board" v-model="form.hear_at">
                                        <label class="form-check-label">
                                             Job Board
                                        </label>   
                                        <br />
                                         <label class="form-check-label ml-20">Current Employee – Name:</label>
                                    <input type="text" class="form-control form-check-input-text" v-model="form.referrer_name">
                                         <label class="form-check-label">Other – Please Explain:</label>
                                    <input type="text" class="form-control form-check-input-text" v-model="form.referrer_other">
                                </div>                             
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label  class="labelbor">Please list any friends or relatives who work here and their relationship to you: 
                                    <input type="text" class="form-control" v-model="form.relative_employee">
                                    </label>
                                </div>                             
                            </div>

                            <div class="form-group">
                                <h2>EDUCATION</h2>
                            </div>

                            <div class="form-row form-row-blue">
                                <div class="form-group col-md-2">
                                 <label>Educational Level</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <label>Name of Institution</label>
                                </div>  
                                <div class="form-group col-md-1">
                                 <label>From</label>
                                </div>
                                <div class="form-group col-md-1">
                                 <label>To</label>
                                </div>  
                                <div class="form-group col-md-2">
                                 <label>Did you graduate?</label>
                                </div> 
                                <div class="form-group col-md-3">
                                 <label>Degree / Major Course of Study</label>
                                </div>                        
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-2">
                                 <label>High School/GED</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.highschool_name">
                                </div>  
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.highschool_from">
                                </div>
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.highschool_to">
                                </div>  
                                <div class="form-group col-md-2">
                                 <select name="Did you graduate High School" v-model="form.highschool_graduated">
                                    <option selected="true">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="In Progress">In Progress</option>
                                 </select>
                                </div> 
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.highschool_major">
                                </div>                        
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-2">
                                 <label>Graduate School</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.gradschool_name">
                                </div>  
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.gradschool_from">
                                </div>
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.gradschool_to">
                                </div>  
                                <div class="form-group col-md-2">
                                 <select name="Did you graduate High School" v-model="form.gradschool_graduated">
                                    <option value="Select" selected="true">Select</option>
                                    <option value="Yes">Yes</option><option value="No">No</option>
                                    <option value="In Progress">In Progress</option>
                                 </select>
                                </div> 
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.gradschool_major">
                                </div>                        
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-2">
                                 <label>College/University</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.college_name">
                                </div>  
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.college_from">
                                </div>
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.college_to">
                                </div>  
                                <div class="form-group col-md-2">
                                 <select name="Did you graduate High School" v-model="form.college_graduated">
                                    <option value="Select" selected="true">Select</option>
                                    <option value="Yes">Yes</option><option value="No">No</option>
                                    <option value="In Progress">In Progress</option>
                                 </select>
                                </div> 
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.college_major">
                                </div>                        
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-2">
                                 <label>Trade/Technical School</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.techschool_name">
                                </div>  
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.techschool_from">
                                </div>
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.techschool_to">
                                </div>  
                                <div class="form-group col-md-2">
                                 <select name="Did you graduate High School" v-model="form.techschool_graduated">
                                    <option value="Select" selected="true">Select</option>
                                    <option value="Yes">Yes</option><option value="No">No</option>
                                    <option value="In Progress">In Progress</option>
                                 </select>
                                </div> 
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.techschool_major">
                                </div>                        
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-2">
                                 <label>Other</label>
                                </div>   
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.eduothers_name">
                                </div>  
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.eduothers_from">
                                </div>
                                <div class="form-group col-md-1">
                                 <input type="text" class="form-control" v-model="form.eduothers_to">
                                </div>  
                                <div class="form-group col-md-2">
                                 <select name="Did you graduate High School" v-model="form.eduothers_graduated">
                                    <option value="Select" selected="true">Select</option>
                                    <option value="Yes">Yes</option><option value="No">No</option>
                                    <option value="In Progress">In Progress</option>
                                 </select>
                                </div> 
                                <div class="form-group col-md-3">
                                 <input type="text" class="form-control" v-model="form.eduothers_major">
                                </div>                        
                            </div>

                            <div>
                                <div class="form-group">
                                    <h2>EMPLOYMENT(LIST UP TO 4 EMPLOYERS, STARTING WITH THE MOST RECENT OR CURRENT)</h2>
                                </div>
                                <div v-for="(employer,index) in form.employers">

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label  class="labelbor">Name of Employer:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.name">
                                            </label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Starting Position:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.start_position">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label  class="labelbor">Street Address:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.street">
                                            </label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Ending Position:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.end_position">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label  class="labelbor">City:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.city">
                                            </label>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label  class="labelbor">State:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.state">
                                            </label>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label>Zip code:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.zip">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label  class="labelbor">Start Date:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.start_date">
                                            </label>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>End Date:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.end_date">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label>Name and title of immediate supervisor:&nbsp;&nbsp;&nbsp;
                                            <input type="text" class="form-control" v-model="employer.supervisor">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                        <label class="form-check-input-main">Current employer?  </label>
                                            <input class="form-check-input" type="radio" value="Yes" v-model="employer.current_employer">
                                                <label class="form-check-label">
                                                    Yes
                                                </label>
                                            <input class="form-check-input" type="radio" value="No" v-model="employer.current_employer">
                                                <label class="form-check-label">
                                                    No
                                                </label>
                                        </div>

                                        <div class="form-group col-md-5">
                                        <label class="form-check-input-main">May we contact this employer?</label>
                                            <input class="form-check-input" type="radio" value="Yes" v-model="employer.contactcurrent_employer">
                                                <label class="form-check-label">
                                                    Yes
                                                </label>
                                            <input class="form-check-input" type="radio" value="No" v-model="employer.contactcurrent_employer">
                                                <label class="form-check-label">
                                                    No
                                                </label>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label>Phone:
                                            <input type="text" class="form-control" v-model="employer.phone">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-row mbt-30">
                                        <div class="form-group col-md-12">
                                            <label>Reason for leaving:
                                            <input type="text" class="form-control" v-model="employer.leaving_reason">
                                            </label>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <a @click="form.employers.splice(index,1)" class="add-employer" v-if="index != 0">Remove</a>
                                    </div>

                                </div>

                                <div class="text-right">
                                    <a @click="cloneEmployer" class="add-employer" v-if="form.employers.length < 4">Add Employer</a>
                                </div>

                            </div>

                            <div class="form-group">
                                <h2>ADDITIONAL QUESTIONS</h2>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">Are you authorized to work in the US for any employer? You will be required to provide proof of employment eligibility upon hire. 
                                    </label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.us_work_visa">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.us_work_visa">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">Are you 18 years of age or older?</label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.above_min_age">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.above_min_age">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">May we contact your present employer? </label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.contact_employer">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.contact_employer">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">Do you have a reliable means of transportation? </label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.transportation">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.transportation">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">Are you able to work overtime if necessary?</label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.overtime">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.overtime">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel inlinelabl">Are there any hours, shifts, days you will not work? If yes, please list: </label>                                    
                                    <input type="text" class="form-control inlinelabl" v-model="form.unavailable_hours">
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.except_workday">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.except_workday">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">If selected for employment, are you willing to submit to a pre-employment drug screening test?</label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.drugscreening_test">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.drugscreening_test">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel">Are you able to perform the essential functions of the job with or without reasonable accommodation?</label>
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.accomodation">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.accomodation">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-9">
                                    <label  class="lastrolabel inlinelabl">Have you ever been fired from a job or asked to resign? If yes, please explain:</label>                                   
                                    <input type="text" class="form-control inlinelabl" v-model="form.fired_reason">
                                </div> 
                                 <div class="form-group col-md-3">
                                    <input class="form-check-input lastrolabelip" type="radio" value="Yes" v-model="form.jobfired">
                                        <label class="form-check-label lastrolabelin">
                                            Yes
                                        </label>
                                    <input class="form-check-input lastrolabelip" type="radio" value="No" v-model="form.jobfired">
                                        <label class="form-check-label lastrolabelin">
                                            No
                                        </label>
                                </div>                                
                            </div>

                             <div class="form-group">
                                <h2>APPLICANT STATEMENT</h2>
                            </div>

                            <div class="form-group">
                                <p>Please read before signing the employment application: </p>
                                <p>ERC is an equal employment opportunity employer.  We adhere to a policy of making employment decisions without regard to race, color, age, sex, religion, national origin, disability, sexual orientation, or marital status.  We assure you that your opportunity for employment with us depends solely on your qualifications.</p>
                                <p>I understand that the employer will thoroughly investigate my work and personal history and verify all data given on this application, on related papers, and in interviews.  I authorize all individuals, schools, and firms named therein, except my current employer if so noted, to provide any information requested about me, and I release them from all liability for damage in providing this information.</p>
                                <p>I understand that the employer follows an “employment at will” policy, in that I or the employer may terminate my employment at any time, or for any reason consistent with applicable state or federal law; this “employment at will” policy cannot be changed verbally or in writing, unless the change is specifically authorized in writing by the Human Resource Director of this organization.  I understand that this application is not a contract of employment.  I understand that federal law prohibits the employment of unauthorized aliens; all persons hired must submit satisfactory proof of employment authorization and identity; failure to submit such proof will result in denial of employment.</p>
                                <p>I understand this application will be active for a period of three months; after that time, if I wish to be considered for employment, I must submit a new application.</p>
                                If employed by ERC, I will comply with any rules or regulations set forth in its employee handbooks, policies and procedures manuals, and in other communications distributed or announced to employees.</p>
                                <p>I hereby waive and release ERC and its directors, officers, employees, agents, and representatives from any and all claims that might arise from reviewing and processing my application and conducting the above-referenced background investigations.  I understand that my employment with ERC and any offer of employment are conditioned on the receipt by ERC of background information completely satisfactory to ERC.  ERC may withdraw an offer of employment or terminate employment if new or different information that reflects negatively on my qualifications or credentials is received by ERC.</p>
                                <p>I certify that all the statements herein are true and understand that any falsification or willful omission shall be sufficient cause for dismissal or refusal of employment</p>
                            </div>

                            <ul>
                                <li v-for="error in formErrors" class="validation-msg">{{ error[0] }}</li>
                            </ul>

                            <vue-recaptcha :sitekey="siteKey" :loadRecaptchaScript="true" @verify="onVerify"></vue-recaptcha>

                            <button class="btn btn-primary" type="submit" :disabled="submitButton.disabled" @click="submitCareer">
                                {{submitButton.name}}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import VueSweetalert2 from 'vue-sweetalert2';
    import VueCloneya from 'vue-cloneya'
    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';
    import VueRecaptcha from 'vue-recaptcha';

    Vue.use(VueCloneya)
    Vue.use(VueSweetalert2);

    export default {
        props: {
            'jobId': Number,
            'jobTitle':String,
        },
        components: {VueRecaptcha},
        data: function () {
            return {
                form: {
                    employers: [{
                        'name' : null,
                        'start_position': null,
                        'street': null,
                        'end_position': null,
                        'city':null,
                        'state':null,
                        'zip':null,
                        'start_date':null,
                        'end_date':null,
                        'supervisor': null,
                        'current_employer': null,
                        'contactcurrent_employer': null,
                        'phone': null,
                        'leaving_reason': null
                    }]
                },
                formErrors: {},
                submitButton: {'name': 'Submit', 'disabled': false},
                loadRecaptchaScript: true,
            }
        },
        methods: {
            maximum(limit) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Max ' + limit + ' Entires can only be entered!',
                });
                console.log(limit);
            },
            submitCareer() {
                this.form.career_id = this.jobId,
                this.form.applied_date = this.getDate;
                let that = this;
                that.submitButton.name = 'Sending';
                that.submitButton.disabled = true;

                axios.post(that.mainUrl + '/careers', {...that.form}).then(function (response) {
                    that.formErrors = {},
                        Vue.$toast.open({
                            message: response.data,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })
                    that.submitButton.name = 'Submit';
                    that.submitButton.disabled = false;
                    that.form.g_recaptcha_response = null;
                    window.grecaptcha.reset();
                    window.location.href=that.mainUrl+'/cms/thank-you';
                })
                .catch(function (error) {
                    Vue.$toast.open({
                        message: "Some error occured! Please Recheck the fields Entered",
                        type: "error",
                        duration: 2000,
                        dismissible: true
                    })
                    that.formErrors = error.response.data.errors;
                    that.submitButton.name = 'Submit';
                    that.submitButton.disabled = false;
                    that.form.g_recaptcha_response = null;
                    window.grecaptcha.reset();
                });
            },
            removeImage: function (e) {
                this.image = '';
            },
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createImage(files[0]);
            },
            createImage(file) {

                var image = new Image();

                var reader = new FileReader();

                var vm = this;

                // reader.onload = (e) => {
                //     vm.image = e.target.result;
                // };


                reader.onload = function (e) {
                    vm.image = {
                        name: file.name,
                        data: e.target.result,
                        type: file.type,
                        size: file.size
                    };
                };


                reader.readAsDataURL(file);
            },
            onVerify(response) {
                this.form.g_recaptcha_response = response;
            },
            cloneEmployer(){
                this.form.employers.push({
                    'name' : null,
                    'start_position': null,
                    'street': null,
                    'end_position': null,
                    'city':null,
                    'state':null,
                    'zip':null,
                    'start_date':null,
                    'end_date':null,
                    'supervisor': null,
                    'current_employer': null,
                    'contactcurrent_employer': null,
                    'phone': null,
                    'leaving_reason': null
                });
            }
        },
        mounted: function () {
            this.form.career_id = this.jobId;
            this.form.applied_date = this.getDate;
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            mainUrl: function () {

                return process.env.MIX_MAIN_URL;
            },
            siteKey: function () {
                return process.env.MIX_GOOGLE_RECAPTCHA_KEY;
            },
            getDate: function(){
                let date = new Date();
                return (date.getMonth()+1)+'-'+date.getDate()+'-'+date.getFullYear();
            }
        }
    }

</script>
<style>
    .validation-error{
        border:1px solid red;
    }
    .validation-msg{
        color: red;
    }
    .add-employer{
        color: white;
        font-weight: bold;
        border: 1px solid #1f3864;
        background: #1f3864 !important;
        padding: 5px;
    }
    .add-employer:hover{
        color: white;
        border: 1px solid #1f3864;
    }
</style>
